import { render, staticRenderFns } from "./TechTransferSave.vue?vue&type=template&id=ab0cd256&"
import script from "./TechTransferSave.vue?vue&type=script&lang=js&"
export * from "./TechTransferSave.vue?vue&type=script&lang=js&"
import style0 from "./TechTransferSave.vue?vue&type=style&index=0&id=ab0cd256&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports